export function getContainingWindow(DOM: HTMLElement) {

	if (window.document.documentElement.contains(DOM)) {
		return window;
	}

	for (let i=0; i<window.frames.length; i++) {
		// Try / catch to not crash on remote frames
		try {
			let frame = window.frames[i];
			let document = frame.document;
			if (document.documentElement.contains(DOM)) {
				return window.frames[i];
			}
		} catch(e) {}
	}

	return null;
}